import { lang } from "../lang";
import { store } from "../store";

function changeLanguage(language: string, country: string): void {
    store.setCountry(country);
    store.setLanguage(language);
    lang.setLanguage(store.language);
    window.location.reload();
}

export { changeLanguage };
